document.addEventListener('DOMContentLoaded', function () {

    // tooltip functionality
    // 1. place the tooltip wrapper element around
    // 2. set the tooltip with the role="tooltip" attribute inside
    // 3. add the class "tooltip-focus" to the element that should show the tooltip on focus

    document.querySelectorAll('.tooltip-wrapper').forEach((wrapper) => {
        const tooltip = wrapper.querySelector("[role='tooltip']");
        if (!tooltip) return;

        const focusableElements = wrapper.querySelectorAll('.tooltip-trigger, [role="tooltip"]');

        // Show tooltip on mouse enter
        wrapper.addEventListener('mouseenter', function () {
            tooltip.classList.remove('visually-hidden');
        });

        // Hide tooltip on mouse leave
        wrapper.addEventListener('mouseleave', function () {
            tooltip.classList.add('visually-hidden');
        });

        // Show tooltip on focus within the wrapper
        wrapper.addEventListener('focusin', function () {
            tooltip.classList.remove('visually-hidden');
        });

        // Hide tooltip when focus leaves the wrapper
        wrapper.addEventListener('focusout', function (event) {
            // Ensure the newly focused element is outside the tooltip wrapper
            if (![...focusableElements].includes(event.relatedTarget)) {
                tooltip.classList.add('visually-hidden');
            }
        });
    });


    // press esc to close all tooltips
    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
            // do something
            // check if any tooltip is active
            document.querySelectorAll('.tooltip').forEach((tooltip) => {
                tooltip.classList.add('visually-hidden');
            });
        }
    });

});

